import React, { AnchorHTMLAttributes, ButtonHTMLAttributes } from "react";
import classNames from "classnames";

type DropdownItemProps = {
  href?: string;
  noFollow?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const DropdownItem: React.FC<DropdownItemProps> = ({
  children,
  className,
  href,
  noFollow,
  ...others
}) => {
  const classes = classNames("dropdown__item", className);

  if (href) {
    return (
      <a
        href={href}
        rel={noFollow ? "nofollow" : undefined}
        className={classes}
        {...(others as AnchorHTMLAttributes<HTMLAnchorElement>)}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      className={classes}
      {...(others as ButtonHTMLAttributes<HTMLButtonElement>)}
    >
      {children}
    </button>
  );
};

export default DropdownItem;
